<template>
	<el-dialog :visible.sync="visible" :title="isBatch ? '批量添加标签' : '编辑标签'" width="480px" :before-close="handleClose">
		<el-form ref="form" label-width="80px">
			<p class="mb-12">
				共选中
				<span class="yx-color-primary">{{ len }}</span>
				个样品订单
				<span v-if="unNum">
					， 其中
					<span class="yx-color-warning">{{ unNum }}</span>
					个订单的标签数量已达到上限，无法添加新的标签
				</span>
			</p>
			<el-form-item label="样品标签" prop="tag_ids">
				<tagSelect ref="tagSelect" type="2" style="width: 100%" :collapseTags="true" :multiple="!isBatch" v-model="tag_ids"></tagSelect>
			</el-form-item>
		</el-form>
		<p class="mt-12 tips">
			没有你想要的标签？你可以
			<span class="color-p-4 cursor-pointer" @click="gotoTagManage">新建标签</span>
		</p>
		<div slot="footer" class="dialog-footer">
			<div>
				<el-button @click="visible = false">取 消</el-button>
				<el-button type="primary" @click="submit" :disabled="isDisabled">确 定</el-button>
			</div>
		</div>
	</el-dialog>
</template>
<script>
import { batchSetSampleTag, setSampleTag, checkSampleTag } from '@/api/sampleOrder';
import tagSelect from '@/components/business/tagSelect';
export default {
	components: { tagSelect },
	props: {},
	computed: {
		isBatch() {
			return this.selectionList.length > 1;
		},
		len() {
			return this.selectionList.length;
		},
	},
	watch: {},
	data() {
		return {
			visible: false,
			tag_ids: '',
			isDisabled: false,
			selectionList: [],
			unNum: 0,
		};
	},
	methods: {
		async getCheckSampleTag() {
			const { code, data } = await checkSampleTag({ sampleSnList: this.selectionList.map(item => item.sample_sn) });
			if (code !== 0) return;
			console.log(data);
			this.unNum = data?.unTaggedNum || 0;
		},
		show(selectionList) {
			this.selectionList = selectionList;
			if (this.selectionList.length === 1) {
				this.tag_ids = this.selectionList[0].sample_tag_list?.length ? this.selectionList[0].sample_tag_list.map(item => item.id) : '';
			} else {
				this.tag_ids = [];
				this.getCheckSampleTag();
			}
			this.visible = true;
		},
		gotoTagManage() {
			this.$router.push({
				path: '/settings/tagManage',
				query: { activeName: '2' },
			});
		},
		async submit() {
			let res;
			if (this.isBatch) {
				res = await batchSetSampleTag({ sampleSnList: this.selectionList.map(item => item.sample_sn), tagId: this.tag_ids });
			} else {
				res = await setSampleTag({ sampleSn: this.selectionList[0].sample_sn, tagIds: this.tag_ids });
			}
			const { code } = res;
			if (code !== 0) return;
			this.$message.success('修改成功');
			this.$emit('refresh');
			this.handleClose();
		},
		handleClose() {
			this.visible = false;
			this.form = {};
			this.$refs.form.resetFields();
		},
	},
};
</script>
<style lang="less" scoped>
.tips {
	width: 100%;
	text-align: right;
}
</style>
